import React, { useState, useEffect, Fragment } from 'react'
import AppointmentService from '../../../../../services/api/appointment.service'
import AppointmentForm from '../appointment-form/AppointmentForm'
import moment from 'moment'
import Toaster from '../../../../templates/components/Toaster'
import APIResponse from '../../../../templates/components/APIResponse';
import * as moment1 from "moment-timezone";
import TimeZoneEnum from '../../../../../common/enum/time-zone.enum';
import Utilities from '../../../../../services/commonservice/utilities'
import ModalBox from '../../../../templates/components/ModalBox'

const EditAppointmentForm = (props) => {
    const [formData, setFormData] = useState()
    const [loader, setLoader] = useState(true)
    const [toasterMessage, setToasterMessage] = useState()
    const [apiResponse, setApiResponse] = useState()
    const [disabled, setDisabled] = useState(false)
    const [ignoreLocationWorkingHours, setIgnoreLocationWorkingHours] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [submitData, setSubmitData] = useState({})
    const [ignoreBookedEquipment, setIgnoreBookedEquipment] = useState(false);
    const onSuccess = (message) => {
        // Reset flags only on success
        setIgnoreLocationWorkingHours(false);
        setIgnoreBookedEquipment(false);
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose(message)
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    useEffect(() => {
        if (ignoreLocationWorkingHours) {
            setConfirmModal(false)
            submitHandler(submitData);
        }
    }, [ignoreLocationWorkingHours])
    useEffect(() => {
        if (ignoreBookedEquipment) {
            setConfirmModal(false)
            submitHandler(submitData);
        }
    }, [ignoreBookedEquipment])

    const onError = (error, showConfirmationModal) => {
        if (showConfirmationModal) {
            // Check if API returns array or string
            const message =
                Array.isArray(error) && error.length > 0
                    ? error[0]
                    : typeof error === "string"
                        ? error
                        : "This appointment encountered an error."; // fallback

            setErrorMessage(message);
            setConfirmModal(true);
        }
    }
    const submitHandler = (data) => {
        setSubmitData(data)
        setDisabled(true);
        //console.log('data',{data});
        let reqObj = {
            "doctorId": data.doctorId && data.doctorId !== "" ? data.doctorId : undefined,
            "fromDate": Utilities.convertUISchedulingDateToDBFormat(data.fromDate),
            "toDate": Utilities.convertUISchedulingDateToDBFormat(data.toDate),
            "day": moment(data.fromDate).day(),
            "duration": data.duration,
            "repeatOn": data.repeatOn,
            "aptTotalCount": data.aptTotalCount,
            "memo": data.memo,
            "phone": data.patientPhone,
            "email": data.email,
            "timeZone": 58, // data?.timeZone? data.timeZone : TimeZoneEnum[moment1.tz.guess()] != undefined ? TimeZoneEnum[moment1.tz.guess()] : TimeZoneEnum["Default"],
            "checkEligibility": data.checkEligibility,
            "patientInsuranceId": data.patientInsuranceId,
            "practicePatientTypeId": data.practicePatientTypeId,
            "practiceLocationId": data.practiceLocationId,
            "practiceServiceTypeId": data.practiceServiceTypeId,
            "practiceServiceType": data.practiceServiceType,
            "practiceAppointmentStatusCodeId": data.practiceAppointmentStatusCodeId,
            "equipmentId": data.equipmentId && data.equipmentId !== "" ? data.equipmentId : undefined,
            "reasonForVisit": data.memo,
            "visitStatus": null,
            "patientId": data.patientId,
            "id": data.id,
            "parentGroupId": data.parentGroupId, //only in edit needed
            "providerRequested": Boolean(data.providerRequested),
            "appointmentLocationType": data.appointmentLocationType || "Office",
            "practiceLocationRoomId": data.practiceLocationRoomId && data.practiceLocationRoomId !== "" ? data.practiceLocationRoomId : undefined
        }
        if (data.childAppointments && data.childAppointments.length > 0) {
            //reset sequence in correct order
            reqObj.childAppointments = data.childAppointments.map((item, index) => {
                item.sequence = index + 1
                item.doctorId = item.doctorId && item.doctorId !== "" ? item.doctorId : undefined
                item.equipmentId = item.equipmentId && item.equipmentId !== "" ? item.equipmentId : undefined
                item.practiceLocationRoomId = item.practiceLocationRoomId && item.practiceLocationRoomId !== "" ? item.practiceLocationRoomId : undefined
                //delete item.sequenceId
                return item
            })
        } else {
            reqObj.childAppointments = [];
        }
        if (ignoreLocationWorkingHours) {
            reqObj.ignoreLocationWorkingHours = ignoreLocationWorkingHours
        }
        if (ignoreBookedEquipment) {
            reqObj.ignoreBookedEquipment = ignoreBookedEquipment
        }
        //console.log("appointment edit "+JSON.stringify(reqObj))  
        AppointmentService.editAppointment(reqObj)
            .then((res) => {
                setApiResponse(res);
                setDisabled(false);
            })
            .catch((err) => {
                setApiResponse(err);
                // Don't reset flags on error - they may need to persist for retry
                setDisabled(false);
            });
    }
    useEffect(() => {
        if (props.id) {
            AppointmentService.getAppointmentById(props.id)
                .then(res => {
                    let arr = res
                    // Removed since dates are now stored as is in the DB and not converted to UTC
                    // arr.fromDate = new Date(arr.fromDate).toISOString()
                    // arr.toDate = new Date(arr.toDate).toISOString()
                    arr.mobile = arr.patientPhone
                    arr.email = arr.email
                    setFormData(arr)
                    return setLoader(false)
                })
                .catch(err => {
                    return setLoader(false)
                })
        }
    }, [props.id])
    useEffect(() => {
        if (props.initialData) {
            setFormData(props.initialData)
            setLoader(false)
        }
    }, [props.initialData])
    return (
        <Fragment>
            {toasterMessage && <Toaster message={toasterMessage} show={toasterMessage} autoClose onClose={() => { setToasterMessage() }} />}
            {!loader && <AppointmentForm disabled={disabled} isModal={props.isModal} submitHandler={submitHandler} initialData={formData} additionalButton={props.additionalButton || null} submitLabel="Update" isEdit onClose={() => { props.onClose() }} />}
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} onError={onError} toastOnSuccess={true} />
            <ModalBox open={confirmModal} onClose={() => setConfirmModal(false)} title="Confirm">
                <div className="row d-flex justify-content-between align-items-center">
                    <div className="col">
                        <p>{errorMessage} Override and create appointment?</p>
                    </div>
                    <div className="col-auto">
                        <button
                            className="btn btn-primary"
                            onClick={(e) => {
                                e.preventDefault();
                                const lowerMessage = errorMessage.toLowerCase();
                                // Check for equipment booking conflict
                                const isEquipmentError = lowerMessage.includes("equipment") && lowerMessage.includes("booked");
                                // Check for location working hours error
                                const isLocationHoursError = lowerMessage.includes("working") && lowerMessage.includes("hours");
                                
                                if (isEquipmentError) {
                                    setIgnoreBookedEquipment(true);
                                } else if (isLocationHoursError) {
                                    setIgnoreLocationWorkingHours(true);
                                } else {
                                    // Default to location working hours for unknown errors
                                    setIgnoreLocationWorkingHours(true);
                                }
                            }}
                        >
                            OK
                        </button>
                        <button
                            className="btn btn-secondary ms-3"
                            onClick={(e) => {
                                e.preventDefault();
                                setConfirmModal(false);
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </ModalBox>
        </Fragment>

    )
}

export default EditAppointmentForm